import { render, staticRenderFns } from "./responsive.vue?vue&type=template&id=70654da5&"
import script from "./responsive.vue?vue&type=script&lang=ts&"
export * from "./responsive.vue?vue&type=script&lang=ts&"
import style0 from "./responsive.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports